// extracted by mini-css-extract-plugin
export default {"logoutButton":"Profile_logoutButton__tbNh1"};